module.exports = __webpack_public_path__ + "static/lunchtype24-light-expanded-webfont-6d002d941fa987d52bb28881d5b225b6.eot";